module.exports = __webpack_public_path__ + "img/3.8a49be6e.png";